export default __webpack_public_path__ + "static/media/869.668b3b51.png";